import React, { useState, useEffect } from "react";
import { Form, Button, Accordion, Modal } from "react-bootstrap";
import CreateCategory from "./CreateCategory";
import { useCategoryData } from "./store";
import { fourPlaceHolder } from "modules/utilities/utility";

const TicketingSettings = () => {
  const [categoryData, setCategoryData] = useState([]);
  const [subcategories, setSubcategories] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false); // Flag to indicate edit mode
  const [editData, setEditData] = useState(null); // Data for editing
  const { fetchCategoryData, categorySubcatData, isLoading } =
    useCategoryData();

  useEffect(() => {
    fetchCategoryData();
  }, []);

  useEffect(() => {
    setCategoryData(categorySubcatData?.data?.category);
    setSubcategories(categorySubcatData?.data?.subcategory);
  }, [categorySubcatData]);

  const handleShowModal = () => {
    setShowModal(true);
    setEditMode(false); // Reset edit mode when adding new category
    setEditData(null); // Reset edit data
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditMode(false);
    setEditData(null);
  };

  const handleEditCategory = (category) => {
    setEditMode(true);
    setEditData({
      category: category, // Pass the category data
      categoryId: category.value,
      subcategories: subcategories[category.value], // Pass the corresponding subcategories
    });
    setShowModal(true);
  };

  const crmCategories = categoryData?.filter(
    (category) => category.source.length === 1 && category.source[0] === "CRM"
  );

  const appCategories = categoryData?.filter((category) =>
    category.source.includes("APP")
  );

  return (
    <div className="container">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <h1>Ticketing Configuration</h1>
        </div>
        <div>
          <Button variant="primary" onClick={handleShowModal}>
            Add Category
          </Button>
        </div>
      </div>

      {isLoading ? (
        fourPlaceHolder()
      ) : (
        <>
          <Form>
            <Accordion>
              <h3>CRM Categories</h3>
              {crmCategories &&
                crmCategories.map((category) => (
                  <Accordion.Item
                    key={category?.value}
                    eventKey={category?.value}
                  >
                    <Accordion.Header>
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div>
                          <h2>{category?.label}</h2>
                        </div>
                        <div className="m-3">
                          <Button
                            variant="warning"
                            className="mx-2"
                            onClick={() => handleEditCategory(category)}
                          >
                            Edit
                          </Button>
                          {/* <Button variant="danger">Delete</Button> */}
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Accordion>
                        {subcategories[category.value]?.map((subcategory) => (
                          <Accordion.Item
                            key={subcategory?.value}
                            eventKey={subcategory?.value}
                          >
                            <Accordion.Header className="">
                              <div className="d-flex justify-content-between align-items-center w-100">
                                <div className="hey">
                                  <h2>{subcategory?.label}</h2>
                                </div>
                              </div>
                            </Accordion.Header>
                            <Accordion.Body>
                              {subcategory?.assigneeDetail?.map((assignee) => (
                                <div key={assignee?.userId} className="assignee">
                                  <div className="d-flex justify-content-between align-items-center">
                                    <h4>{assignee?.firstName}</h4>
                                  </div>
                                </div>
                              ))}
                            </Accordion.Body>
                          </Accordion.Item>
                        ))}
                      </Accordion>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
            </Accordion>
            <div className="mt-4">
              <Accordion>
                <h3>APP Categories</h3>
                {appCategories &&
                  appCategories.map((category) => (
                    <Accordion.Item
                      key={category.value}
                      eventKey={category.value}
                    >
                      <Accordion.Header>
                        <div className="d-flex justify-content-between align-items-center w-100">
                          <div>
                            <h2>{category?.label}</h2>
                          </div>
                          <div className="m-3">
                            <Button
                              variant="warning"
                              className="mx-2"
                              onClick={() => handleEditCategory(category)}
                            >
                              Edit
                            </Button>
                            {/* <Button variant="danger">Delete</Button> */}
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <Accordion>
                          {subcategories[category.value]?.map((subcategory) => (
                            <Accordion.Item
                              key={subcategory?.value}
                              eventKey={subcategory?.value}
                            >
                              <Accordion.Header className="">
                                <div className="d-flex justify-content-between align-items-center w-100">
                                  <div className="hey">
                                    <h2>{subcategory?.label}</h2>
                                  </div>
                                </div>
                              </Accordion.Header>
                              {/* <Accordion.Body>
                                {subcategory.assigneeDetail?.map((assignee) => (
                                  <div
                                    key={assignee.userId}
                                    className="assignee"
                                  >
                                    <div className="d-flex justify-content-between align-items-center">
                                      <h4>{assignee.firstName}</h4>
                                    </div>
                                  </div>
                                ))}
                              </Accordion.Body> */}
                              <Accordion.Body>
                                {subcategory.faqs &&
                                subcategory.faqs.length > 0 ? (
                                  <Accordion>
                                    {subcategory.faqs.map((faq, index) => (
                                      <Accordion.Item
                                        key={index}
                                        eventKey={`faq-${index}`}
                                      >
                                        <Accordion.Header>
                                          FAQ: {faq.display_name}
                                        </Accordion.Header>
                                        <Accordion.Body>
                                          {faq.faq_ans}
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    ))}
                                  </Accordion>
                                ) : (
                                  subcategory.assigneeDetail?.filter(Boolean)?.map(
                                    (assignee) => (
                                      <div
                                        key={assignee.userId}
                                        className="assignee"
                                      >
                                        <div className="d-flex justify-content-between align-items-center">
                                          <h4>{assignee.firstName}</h4>
                                        </div>
                                      </div>
                                    )
                                  )
                                )}
                              </Accordion.Body>
                            </Accordion.Item>
                          ))}
                        </Accordion>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
              </Accordion>
            </div>
          </Form>
          <Modal show={showModal} fullscreen={true} onHide={handleCloseModal}>
            <Modal.Header closeButton>
              <Modal.Title>
                {editMode ? `Edit ${editData?.category?.label} Category` : "Add Category"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <CreateCategory
                editMode={editMode}
                editData={editData}
                setShowModal={setShowModal}
              />
            </Modal.Body>
          </Modal>
        </>
      )}
    </div>
  );
};

export default TicketingSettings;
